import type { KPIPeriodFilter } from "@/modules/kpi/domain/types";
import type { KPIOverviewExplainArgs } from "@/modules/kpi/presentation/api/queries";
import { buildKpiOverviewExplainSearch } from "@/modules/kpi/presentation/utils/kpi-overview-explain-search";
import type { MeProfileKpiResultRowDTO } from "@/modules/users/domain/employee-profile.types";

/**
 * ສ້າງ search ສຳລັບ `/app/management/okr-kpi/explain` ຈາກແຖວຜົນ KPI ໃນໂປຣໄຟລ໌
 */
export function buildProfileKpiExplainSearch(
  row: MeProfileKpiResultRowDTO,
): ReturnType<typeof buildKpiOverviewExplainSearch> | null {
  if (row.periodYear == null) return null;
  const year = row.periodYear;
  let filter: KPIPeriodFilter;
  if (row.measurementPeriod === "monthly" && row.periodMonth != null) {
    filter = { periodType: "monthly", year, month: row.periodMonth };
  } else if (
    row.measurementPeriod === "quarterly" &&
    row.periodQuarter != null
  ) {
    filter = { periodType: "quarterly", year, quarter: row.periodQuarter };
  } else {
    filter = {
      periodType: "monthly",
      year,
      month: row.periodMonth ?? 1,
    };
  }

  const args: KPIOverviewExplainArgs = {
    scope: "employee",
    kpiId: row.kpiId,
    includeSources: true,
    includeRecordSamples: true,
  };
  return buildKpiOverviewExplainSearch(filter, args);
}
